var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lastthreadmsgs"},[_c('b-card',{attrs:{"_title":"Communications"}},[_c('AgGridVue',{staticClass:"ag-theme-alpine",style:(`height: 280px;width: 100%`),attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.msgs,"defaultColDef":_vm.defaultColDef,"suppressColumnVirtualisation":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }